import React, { useMemo } from 'react'
import useGetData from 'hooks/useGetData'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'

const DefaultBoardTemplate = ({
  intl,

  boardTemplateId,
  onChange
}) => {
  const {
    data,
  } = useGetData('BoardTemplates')

  const options = useMemo(() => {
    if (data) {
      const options = data.Templates.map(Template => ({
        value: String(Template.Id),
        name: Template.Name,
      }))

      if (boardTemplateId && !data.Templates.find(Template => Template.Id === boardTemplateId)) {
        options.unshift({
          value: boardTemplateId,
          name: `- ${intl.formatMessage({ id: 'BOARD_TILE_ACCESS_DENIED' })} -`,
        })
      }

      return options
    }

    return null
  }, [intl, boardTemplateId, data])

  return (
    <FormGroup>
      <ControlLabel><FormattedMessage id='DEFAULT_BOARD_TEMPLATE' /></ControlLabel>
      <FormControl
        componentClass='select'
        value={String(boardTemplateId)}
        onChange={onChange}
      >
        {options ? (
          <React.Fragment>
            <FormattedMessage id='DEFAULT_BOARD_TEMPLATE_NONE'>
              {(formattedMessage) => (
                <option value='null'>{formattedMessage}</option>
              )}
            </FormattedMessage>
            {options.map(option =>
              <option
                key={option.value}
                value={option.value}
              >
                {option.name}
              </option>
            )}
          </React.Fragment>
        ) : (
          <FormattedMessage id='LOADING'>
            {(formattedMessage) => (
              <option value='null'>{formattedMessage}</option>
            )}
          </FormattedMessage>
        )}
      </FormControl>
    </FormGroup>
  )
}

export default injectIntl(DefaultBoardTemplate, { forwardRef: true })